import Sprite = PIXI.Sprite;
import Container = PIXI.Container;
import Point = PIXI.Point;
import TextStyle = PIXI.TextStyle;
import { AbstractPopUp, AbstractPopUpParams } from '../AbstractPopUp';
import { Button } from '../../UI/elements/buttons/Button';
import { PopUpName } from '../../core/managers/PopUpManager';
import {
    createSprite,
    resizeTextByReference,
} from '../../utils/GameEngine';
import { TextStyles } from '../../utils/TextStyles';
import { TextIncrement } from '../../UI/elements/TextIncrement';
import { SceneManager } from '../../core/managers/SceneManager';
import { CoreGameplay } from '../../core/gameplay/CoreGameplay';
import { clearAnimations } from '../../utils/Animations';

export interface WinPopUpParams extends AbstractPopUpParams {
    returnFunction: () => void;
    rewardInCoins: number;
    core: CoreGameplay;
}

export class WinPopUp extends AbstractPopUp {
    protected returnFunction: () => void;
    protected continueButton: Button;
    protected increments: TextIncrement[];
    protected core: CoreGameplay;
    private movingBGs: PIXI.Container[];
    private overlayContainer: PIXI.Container;
    private hidden: boolean = false;

    constructor(public readonly name: PopUpName, params: WinPopUpParams) {
        super(name, params);
        this.returnFunction = params.returnFunction;
        this.core = params.core;
    }

    protected drawLayout(params?: any): void {
        super.drawLayout(params);
        this.addUnderlay(params.core);
    }

    public show(): void {
        super.show();
        this.overlayContainer = new Container();
        SceneManager.getInstance().stage.addChild(this.overlayContainer);
        this.addUnderlay(this.overlayContainer, 'win_donuts_front', 40000, 1, false);
    }

    private addUnderlay(
        parent: any,
        texture: string = 'donuts_pattern_blur_win',
        distance: number = 20000,
        alpha: number = 1,
        interactive: boolean = true
    ): void {
        const movingBG: Container = new Container();
        if (!this.movingBGs) {
            this.movingBGs = [];
        }
        this.movingBGs.push(movingBG);
        movingBG.alpha = alpha;
        movingBG.interactive = interactive;
        let lastStep: number = 1;
        const stage: Container = SceneManager.getInstance().stage;
        parent.addChild(movingBG);
        const tile1: Sprite = createSprite(texture, movingBG);
        const tile2: Sprite = createSprite(texture, movingBG);
        const tileHeight: number = tile1.height;
        tile2.y = -tile1.height;
        TweenLite.to(movingBG, 300, {
            y: distance,
            onUpdate: (): void => {
                if (movingBG.y > tileHeight * lastStep) {
                    const tileToMove: Sprite = movingBG.children[0] as Sprite;
                    const otherTile: Sprite = movingBG.children[1] as Sprite;
                    tileToMove.y = otherTile.y - tileHeight;
                    movingBG.addChildAt(otherTile, 0);
                    lastStep++;
                }
            }
        });
    }

    protected addFirstText(topOffset: number): void {
        const style: TextStyle = TextStyles.uiText.clone();
        style.wordWrapWidth = this.textBox.width - 16;
        style.fill = '#ffe600';
        this.text = new PIXI.Text(this.params.text, style);
        this.text.anchor.set(0.5, 0.5);
        resizeTextByReference(this.text, this.textBox, 0);
        this.text.position.set(
            this.textBox.x + this.textBox.width / 2,
            this.textBox.y + topOffset * 3
        );
        this.background.addChild(this.text);
    }

    public hide(quick: boolean = false): void {
        super.hide(quick);
        if (!this.hidden) {
            if (this.closeButton) {
                this.closeButton.interactive = false;
            }
            if (this.continueButton) {
                this.continueButton.interactive = false;
            }
            this.returnFunction();

            this.movingBGs.forEach((obj: Container): void => {
                clearAnimations(obj);
                obj.destroy({children: true});
            });
            this.hidden = true;
        }
    }

    public destroy(options?: any): void {
        if (this.increments) {
            this.increments.forEach((increment: TextIncrement): void => {
                increment.stop();
                increment.destroy();
            });
        }
        super.destroy(options);
    }
}